import { CalendarIntervalModel, CalendarModel } from '@bryntum/schedulerpro';
import { WorkingDaysConfiguration } from 'components/organisms/user-capacity';

const allWorkingDay = () =>
  new CalendarModel({
    id: '24h',
    unspecifiedTimeIsWorking: true,
  });

export const getCalendars = (
  workingDaysConfig: WorkingDaysConfiguration,
): CalendarModel[] => [
  new CalendarModel({
    id: 'nonWorkingDays',
    intervals: Object.keys(workingDaysConfig)
      .filter((key) => !workingDaysConfig[key])
      .map(
        (key) =>
          new CalendarIntervalModel({
            recurrentStartDate: `on ${key} at 0:00`,
            recurrentEndDate: `on ${key} at 23:59`,
            isWorking: false,
          }),
      ),
    unspecifiedTimeIsWorking: true,
  }),
  allWorkingDay(),
];
